// @flow

import * as React from 'react';

import UserSessionStore from 'app/stores/UserSessionStore';
import JobLogStore, { type JobPartial, type Job } from 'app/stores/JobLogStore';

import LegacyLoading from 'app/components/shared/LegacyLoading';

import JobLogOutputGroup from './Group';

type Props = {
  onChange: (changed: Job) => mixed,
  job: JobPartial,
  timestampsOn: ?boolean,
  children: React.Node
};

type State = {
  log: Job,
  timestampsInUTC?: ?boolean
};

const getStateFromStore = (job) => ({ log: JobLogStore.load(job) });

const USER_SESSION_STORE_TIMESTAMP_UTC_KEY = "job-log-timestamps-utc";

export default class JobLogOutput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = getStateFromStore(props.job);
  }

  componentDidMount() {
    JobLogStore.addChangeListener(this.state.log.id, this.handleStoreChange);
  }

  componentWillUnmount() {
    JobLogStore.removeChangeListener(this.state.log.id, this.handleStoreChange);
  }

  handleStoreChange = () => {
    this.setState(getStateFromStore(this.props.job));
    this.props.onChange(this.state.log);
  }

  isTimestampsInUTC() {
    // If timestmaps haven't been manually turned on in this log, use what ever
    // they chose last.
    if (this.state.timestampsInUTC === undefined) {
      // Values are stored as strings, so we'll need to convert it
      return UserSessionStore.get(USER_SESSION_STORE_TIMESTAMP_UTC_KEY) === "true";
    }

    return this.state.timestampsInUTC;
  }

  handleTimestampClick = () => {
    const timestampsInUTC = !this.state.timestampsInUTC;
    this.setState({ timestampsInUTC: timestampsInUTC });

    // Store it so next time we default to that choice
    UserSessionStore.set(USER_SESSION_STORE_TIMESTAMP_UTC_KEY, timestampsInUTC.toString());
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // TODO: This is a total hack, and probably shouldnt' be done here. If the
    // state of the job has changed, then reload the job log.
    if (this.props.job.state !== nextProps.job.state) {
      JobLogStore.refresh(this.state.log.id);
    }
  }

  render() {
    const { log } = this.state;
    const timestampsInUTC = this.isTimestampsInUTC();

    const contentNode = (
      log.loaded
        ? (
          <table
            className={`JobLogOutputComponent__Table--${log.totalLines.toString().length}Column`}
          >
            {log.groups.map((group) => (
              <JobLogOutputGroup
                timestampsOn={this.props.timestampsOn}
                timestampsInUTC={timestampsInUTC}
                onTimestampClick={this.handleTimestampClick}
                key={group.id}
                {...group}
              />
            ))}
          </table>
        )
        : (
          !this.props.job.startedAt
            ? <div className="JobLogOutputComponent__Loader" />
            : (
              <div className="JobLogOutputComponent__Loader">
                <LegacyLoading />
              </div>
            )
        )
    );

    return (
      <div className="JobLogOutputComponent">
        <div className="JobLogOutputComponent__Controls z0">
          {this.props.children}
        </div>
        <div className="JobLogOutputComponent__Body">
          {contentNode}
        </div>
      </div>
    );
  }
}
